export default "__VITE_ASSET__Ci0$y2GD__"